import React, { createContext, useEffect, useState } from "react";
import { db } from "./Firebase-Config";
import { doc, getDoc } from "firebase/firestore";
import { UserAuth } from "./AuthContext";

export const UserProfileContext = createContext();

const UserProfileContextProvider = (props) => {

  const {user} = UserAuth()

  // eslint-disable-next-line
  const [pending, setPending] = useState(false);
  // eslint-disable-next-line
  const [status, setStatus] = useState("");

  const [userData, setUserData] = useState()

  
  useEffect(() => {

    if (!user) {
      return;
    }
    // eslint-disable-next-line
    getUserData()
    // console.log(auth.currentUser.uid);
// eslint-disable-next-line
  }, [user]);

  const getUserData = async () => {
    const userDocRef = doc(db, "users", user.uid);

    const docSnap = await getDoc(userDocRef);

    if (docSnap.exists()) {
      setUserData({id: docSnap.id, data:docSnap.data()})
    } else {
      setStatus("blocked");
    }
  };

  if (pending) {
    return <>Loading...</>;
  }

  return (
    <UserProfileContext.Provider
      value={{
        userData,
      }}
    >
      {props.children}
    </UserProfileContext.Provider>
  );
};

export default UserProfileContextProvider;



